/**
 * Converts milliseconds to total number of days
 */
export const msToDays = (ms: number): number => Math.floor(ms / (1000 * 60 * 60 * 24))

/**
 * Converts milliseconds to total number of hours
 */
export const msToHours = (ms: number): number => Math.floor(ms / (1000 * 60 * 60))

/**
 * Converts milliseconds to total number of minutes
 */
export const msToMinutes = (ms: number): number => Math.floor(ms / (1000 * 60))

/**
 * Converts milliseconds to total number of seconds
 */
export const msToSeconds = (ms: number): number => Math.floor(ms / 1000)
